import { Icon, IconsEnum } from 'components/Icons';
import { ButtonMsgCenter } from 'features/signup/types';
import classNames from 'classnames';
import styles from './Alert.module.scss';
import { useEffect } from 'react';

export type AlertProps = {
  icon: IconsEnum;
  message: string;
  color?: string;
  animation?: boolean;
  btn?: ButtonMsgCenter[];
  actionAfterTimeout?: () => void;
};

export const Alert = ({ icon, message, color, animation, actionAfterTimeout, btn }: AlertProps) => {
  useEffect(() => {
    let timeout;
    if (animation) {
      timeout = setTimeout(() => {
        if (actionAfterTimeout) actionAfterTimeout();
      }, 10000);
    }
    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [animation, actionAfterTimeout]);

  return (
    <div suppressHydrationWarning className={classNames(styles.container)}>
      <div className={styles.content} suppressHydrationWarning>
        <div className={styles.icon} suppressHydrationWarning>
          <Icon iconId={icon} color={color} className={styles.icon} />
        </div>
        <p dangerouslySetInnerHTML={{ __html: message }} suppressHydrationWarning />
        <div className={styles.containerButtons} suppressHydrationWarning>
          {Array.isArray(btn) &&
            btn?.map((btn, index) => (
              <a
                key={index}
                className={styles.buttonText}
                href={!btn.link?.includes('http') && !btn.link?.includes('https') ? `https://${btn.link}` : btn.link}
                target={btn.target}
                suppressHydrationWarning
              >
                {btn.testo}
              </a>
            ))}
        </div>
      </div>
      {!animation && (
        <button className={styles.closeButton} onClick={actionAfterTimeout} suppressHydrationWarning>
          <Icon iconId={IconsEnum.CLOSE} />
        </button>
      )}
    </div>
  );
};
